const getPlaceholder = (o) => {
  // return o?.field_tip ? o?.field_tip : o.field_name ? o.field_name : null
  return o?.field_tip ? o?.field_tip : null
}
export const renderFun = {
  input(o) {
    return (
      <a-col xs={24} sm={24} md={24} lg={12} xl={12}>
        <a-form-model-item label={o.field_name} prop={o.field_id}>
          <a-input autocomplete="off" maxLength={1000} vModel={this.expandForm[o.field_id]} allowClear placeholder={getPlaceholder(o)} />
        </a-form-model-item>
      </a-col>
    )
  },
  number(o) {
    return (
      <a-col xs={24} sm={24} md={24} lg={12} xl={12}>
        <a-form-model-item label={o.field_name} prop={o.field_id}>
          <a-input-number style="width:100%;" vModel={this.expandForm[o.field_id]} allowClear placeholder={getPlaceholder(o)} precision={2}/>
        </a-form-model-item>
      </a-col>
    )
  },
  textarea(o) {
    return (
      <a-col xs={24} sm={24} md={24} lg={12} xl={12}>
        <a-form-model-item label={o.field_name} prop={o.field_id}>
          <a-input vModel={this.expandForm[o.field_id]} type="textarea" allowClear placeholder={getPlaceholder(o)} />
        </a-form-model-item>
      </a-col>
    )
  },
  radio(o) {
      function renderRadioGroup(o) {
        let renderDom = null
        if (Array.isArray(o.options) && o.options.length) {
          renderDom = (<a-radio-group vModel={this.expandForm[o.field_id]} options={o.options}>
          </a-radio-group>)
        } else if (Array.isArray(o.label) && o.label.length) {
          renderDom = (
            <a-radio-group vModel={this.expandForm[o.field_id]}>
            {
              this[o.label].map(o => (
                <a-radio key={o.key} value={o.key}>{ o.value }</a-radio>
              ))
            }
          </a-radio-group>
          )
        }
        return renderDom
      }
      return (<a-col xs={24} sm={24} md={24} lg={12} xl={12}>
        <a-form-model-item label={o.field_name} prop={o.field_id}>
          {renderRadioGroup.call(this, o)}
        </a-form-model-item>
      </a-col>
    )
  },
  checkbox(o) {
    const options = Array.isArray(o.options) ? o.options : []
    return (
      <a-col xs={24} sm={24} md={24} lg={12} xl={12}>
        <a-form-model-item label={o.field_name} prop={o.field_id}>
          <a-checkbox-group
            vModel={this.expandForm[o.field_id]}
            options={options}
          />
        </a-form-model-item>
      </a-col>
    )
  },
  datePicker(o) {
    return (
      <a-col xs={24} sm={24} md={24} lg={12} xl={12}>
        <a-form-model-item label={o.field_name} prop={o.field_id}>
          <VDatePicker style="width: 100%;" vModel={this.expandForm[o.field_id]} placeholder={getPlaceholder(o)} />
        </a-form-model-item>
      </a-col>
    )
  },
  upload(o) {
    return (
      <a-col xs={24} sm={24} md={24} lg={12} xl={12}>
        <a-form-model-item style="height: 150px" label={o.field_name} prop={o.field_id}>
          <yzImageUpload domains={this.QI_NIU_DOMAINS} text={o.field_tip ? o.field_tip : undefined} headers={{ token: this.token }} number={o?.field_value?.[0]?.pic_num ?? 1} accept="image/*" vModel={this.expandForm[o.field_id]} isMultiple={true} />
        </a-form-model-item>
      </a-col>
    )
  },
  editor(o) {
    return (
      <a-col xs={24} sm={24} md={24} lg={19} xl={19}>
        <a-form-model-item label={o.field_name} prop={o.field_id} label-col={{ span: 3 }} wrapper-col={{ span: 18 }}>
          <div class="flex">
            <Editor id={o.field_id} vModel={this.expandForm[o.field_id]} style="width: 900px" />
          </div>
          {
            this.contentHtml && <div domPropsInnerHTML={this.contentHtml}></div>
          }
        </a-form-model-item>
      </a-col>
    )
  },
}
